export const DEFAULT_PARAMETERIZED_SUBJECT =
    'Splunk Observability{{#if anomalous}} {{ruleSeverity}} Alert: {{{ruleName}}} ({{{detectorName}}}){{else}} - Back to normal: {{{ruleName}}} ({{{detectorName}}}){{/if}}';
